import { extractListItems } from './extractListItems';

type PaginatedResult<T> = {
  items: T[];
  nextToken?: string | null;
};

const MAX_PAGES = 1000;

export const fetchAllPaginatedItems = async <T>(
  fetchFn: (
    nextToken?: string | null
  ) => Promise<PaginatedResult<T> | null | undefined>
): Promise<NonNullable<T>[]> => {
  const allItems: NonNullable<T>[] = [];
  let nextToken: string | null | undefined;
  let pageCount = 0;

  do {
    pageCount++;

    if (pageCount > MAX_PAGES) {
      throw new Error(
        `fetchAllPaginatedItems exceeded maximum of ${MAX_PAGES} pages. ` +
          `Collected ${allItems.length} items before stopping.`
      );
    }

    const response = await fetchFn(nextToken);
    if (!response) break;

    const items = extractListItems(response.items ?? []);
    allItems.push(...items);

    if (response.nextToken && response.nextToken === nextToken) {
      throw new Error(
        `fetchAllPaginatedItems detected repeated nextToken "${response.nextToken}". ` +
          `Collected ${allItems.length} items before stopping.`
      );
    }

    nextToken = response.nextToken;
  } while (nextToken);

  return allItems;
};
